import React from "react";
import Axios from 'axios'
import MasterTemplate from "./MasterTemplate";
import { Link } from 'react-router-dom';



export class InformacoesSistema extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      TotalEmVendas: 0,
      TotalEmVendasDiretas: 0,
      TotalEmVendasOnline: 0,
      TotalEmVendasVulsas: 0,
      cartelas: [],
      cartelasRecebidas: [],
      cartelasValidadas: [],
      cartelasLotes: [],
      cartelasSeries: [],
      transacoes: [],
      pedidos: [],
      series: [],
      lotes: [],
      parametros: null,
      cartelasPeFrio: [],
      user: JSON.parse(localStorage.getItem("user")),
    };
    this.listarLotes();
    this.listarSeries();
    this.listarPedidos();
    this.listarTransacoes();
    this.getParametros()
  }

  refreshCartelasPeFrio = async () => {
    this.getParametros()
    // var arrayAux = [...this.state.cartelasPeFrio]
    // arrayAux.map((cartela, index) => {
    //   this.state.parametros.currentNumeros.map(numero => {
    //     console.log(cartela.numeros.join(','))
    //     if (cartela.numeros.includes(numero)) {
    //       console.log(this.state.cartelasPeFrio.splice(index, 1))
    //     }
    //   })
    // })

  }

  getParametros = async () => {
    var axiosInstance = new Axios.create({
      baseURL: window.localStorage.getItem("apiUrl")
    });
    const response = await axiosInstance.get('/parametros')
    this.setState({ parametros: response.data })
    console.log(response.data)
  }

  async listarLotes() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("lotes/get-total-lotes-justcat");
      this.setState({ lotes: response.data });
      this.getCartelasLotes();
    } catch (err) {
      console.log(err);
    }
  };

  async listarSeries() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("series/get-total-series-justcat");
      this.setState({ series: response.data });
      this.getCartelasSeries();
    } catch (err) {
      console.log(err);
    }
  };

  async listarPedidos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("pedidos/get-total-pedidos-justcat");
      this.setState({ pedidos: response.data });
      this.getCartelasVendidas()
    } catch (err) {
      console.log(err);
    }
  }

  async listarTransacoes() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("transacoes/get-total-transacoes-justcat");
      this.setState({ transacoes: response.data });
      this.getVendas();
    } catch (err) {
      console.log(err);
    }
  }

  getVendas() {
    var TotalEmVendas = 0
    var TotalEmVendasDiretas = 0;
    var TotalEmVendasOnline = 0;
    var TotalEmVendasVulsas = 0;
    this.state.transacoes.map(transacao => {
      if (transacao.tipo === 'Venda' && transacao.receptorId !== this.state.user._id)
        TotalEmVendas += parseFloat(transacao.valor);
      if (transacao.receptorId === this.state.user._id)
        TotalEmVendasDiretas += parseFloat(transacao.valor);
      if (transacao.tipo === 'Venda' && transacao.documento === 'Documento Avulso' && transacao.receptorId !== this.state.user._id)
        TotalEmVendasVulsas += parseFloat(transacao.valor);
      if (transacao.tipo === 'Venda' && transacao.documento !== 'Documento Avulso' && transacao.receptorId !== this.state.user._id)
        TotalEmVendasOnline += parseFloat(transacao.valor);
    })
    this.setState({ TotalEmVendas: TotalEmVendas, TotalEmVendasOnline: TotalEmVendasOnline, TotalEmVendasDiretas: TotalEmVendasDiretas, TotalEmVendasVulsas: TotalEmVendasVulsas })
  }


  getCartelasVendidas() {
    var cartelas = []
    var cartelasRecebidas = [];
    var cartelasValidadas = [];
    this.state.pedidos.map(pedido => {
      pedido.cartelas.map(cartela => {
        cartelas.push({ cartela })
        if (pedido.recebido)
          cartelasRecebidas.push(cartela);
        if (pedido.validado)
          cartelasValidadas.push(cartela);
      })
    })
    this.setState({ cartelas: cartelas, cartelasRecebidas: cartelasRecebidas, cartelasValidadas: cartelasValidadas, cartelasPeFrio: [...cartelasValidadas] })
  }

  getCartelasLotes() {
    var cartelas = []
    this.state.lotes.map(lote => {
      lote.cartelas.map(cartela => {
        cartelas.push({ cartela })
      })
    })
    this.setState({ cartelasLotes: cartelas })
  }

  getCartelasSeries() {
    var cartelas = []
    this.state.series.map(serie => {
      serie.cartelas.map(cartela => {
        cartelas.push({ cartela })
      })
    })
    this.setState({ cartelasSeries: cartelas })
  }


  render() {
    return (
      <MasterTemplate label="Informações do sistema">
        <div className="bg-white rounded border p-5">
          <div className="row bg-dark justify-content-center">
            <span className="font-weight-bold text-light">INFORMAÇÕES DE CARTELAS</span>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Total de cartelas em pedidos: </th>
                <th scope="col">Cartelas recebidas: </th>
                <th scope="col">Cartelas validadas: </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pl-5 font-weight-bold text-dark">{this.state.cartelas.length}</td>
                <td className="pl-5 font-weight-bold text-warning">{this.state.cartelasRecebidas.length}</td>
                <td className="pl-5 font-weight-bold text-success">{this.state.cartelasValidadas.length}</td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Total de cartelas em Lote: </th>
                <th scope="col">Cartelas em series: </th>
                <th scope="col">Cartelas pé frio: </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pl-5 font-weight-bold text-dark">{this.state.cartelasLotes.length}</td>
                <td className="pl-5 font-weight-bold text-dark">{this.state.cartelasSeries.length}</td>
                <td className="pl-5 font-weight-bold text-info">
                  <div className="row">

                    <button onClick={this.refreshCartelasPeFrio.bind(this)} >{this.state.parametros?.currentNumeros.length ? parseInt(this.state.cartelasPeFrio.length / this.state.parametros.currentNumeros.length) : 0} <i class="fa fa-refresh" aria-hidden="true"></i></button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row bg-dark justify-content-center">
            <span className="font-weight-bold text-light">INFORMAÇÕES DE VENDAS</span>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Valor total em vendas: </th>
                <th scope="col">Total em vendas diretas: </th>
                <th scope="col">Total em vendas cambistas Online:  </th>
                <th scope="col">Total em vendas avulsas: </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pl-5 font-weight-bold text-dark">R$:{this.state.TotalEmVendas}</td>
                <td className="pl-5 font-weight-bold text-dark">R$:{this.state.TotalEmVendasDiretas}</td>
                <td className="pl-5 font-weight-bold text-dark">R$:{this.state.TotalEmVendasOnline}</td>
                <td className="pl-5 font-weight-bold text-dark">R$:{this.state.TotalEmVendasVulsas}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </MasterTemplate>
    );
  }
}

export default InformacoesSistema;
